/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Push_OnInputs */

const en_settings_push_on = /** @type {(inputs: Settings_Push_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications are on for this device.`)
};

const he_settings_push_on = /** @type {(inputs: Settings_Push_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ההתראות מופעלות במכשיר הזה.`)
};

/**
* | output |
* | --- |
* | "Notifications are on for this device." |
*
* @param {Settings_Push_OnInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_push_on = /** @type {((inputs?: Settings_Push_OnInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Push_OnInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_push_on(inputs)
	return he_settings_push_on(inputs)
});